import axiosInstance from "./axiosConfig";

// getAuthType API Call
export const getAuthType = async () => {
  const response = await axiosInstance.get(`/authentication-type`);
  // console.log(response.data);
  return response.data;
};

// Login API Call
export const loginUser = async (mobile, password) => {
  const response = await axiosInstance.post(`/login`, {
    mobile,
    password,
  });
  return response.data;
};

// check the player name should be unique when register
export const checkPlayerName = async (player_name) => {
  const response = await axiosInstance.get(`/check-player-name`, {
    params: { player_name },
  });
  return response.data; // expected: { status: "success" } or { status: "error", msg: "Already exists" }
};
// register with mobile and password
export const registerUser = async (data) => {
  const payload = {
    player_name: data.player_name || data.username,
    mobile: data.mobile,
    password: data.password,
    ...(data.referral_code ? { referral_code: data.referral_code } : {}),
  };
  const response = await axiosInstance.post(`/register`, payload);
  return response.data;
};

// Resend OTP API Call
// export const resendOTP = async (data) => {
//   const payload = typeof data === "string" ? { mobile: data } : data;
//   const response = await axiosInstance.post(`/resend-otp`, payload);
//   return response.data;
// };

// OTP verification API
// export const verifyOTP = async (data) => {
//   const response = await axiosInstance.post(
//     `/authentication-otp-verify`,
//     data
//   );
//   return response.data;
// };

// OTP verification API
export const verifyOTP = async ({ otp, mobile, type, authType }) => {
  try {
    const response = await axiosInstance.post(`/authentication-otp-verify`, {
      otp,
      mobile,
      type,
    });

    return response.data;
  } catch (error) {
    console.error("OTP Verify Error:", error.response?.data);
    throw error;
  }
};
// Forgot Password OTP Generate API Call
export const forgotPasswordOtpGenerate = async (data) => {
  const payload = typeof data === "string" ? { mobile: data } : data;
  const response = await axiosInstance.post(
    `/forgot-password-otp-generate`,
    payload
  );
  return response.data;
};

// Forgot Password OTP Verify API Call
export const forgotPasswordOtpVerify = async (data) => {
  const response = await axiosInstance.post(
    `/forgot-password-otp-verify`,
    data
  );
  return response.data;
};

// New Password Create API Call
export const newPasswordCreate = async (data) => {
  const response = await axiosInstance.post(`/new-password-create`, data);
  return response.data;
};

// ✅ Get User Profile
export const getUserProfile = async (token) => {
  try {
    const response = await axiosInstance.get("/player/profile", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.status === "success") {
      // console.log(response.data);

      return response.data.player; // ✅ Return only player data
    } else {
      throw new Error(response.data.msg || "Failed to load profile");
    }
  } catch (error) {
    console.error("Profile API Error:", error);
    throw new Error("Something went wrong. Please try again.");
  }
};
// Logout API Call
export const logoutUser = async () => {
  const response = await axiosInstance.post("/player/logout");
  return response.data;
};

// verify token
// export const verifyToken = async () => {
//   const response = await axiosInstance.get("/player/verify-token");
//   return response.data;
// };
// export const verifyToken = async () => {
//   const response = await axiosInstance.get("/player/verify-token");
//   return response.data;
// };

export const verifyToken = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("Token not found in localStorage");
  }

  const response = await axiosInstance.get("/player/verify-token", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

// Fetch player bonuses
export const getPlayerBonusInfo = async (token) => {
  const response = await axiosInstance.get("/player/player-bonus-info", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const getPortalInfo = async () => {
  const response = await axiosInstance.get("/portal-info");
  return response.data;
};

// Fetch player bonuses
export const getPlayerReferralInfo = async (token) => {
  const response = await axiosInstance.get("/player/player-referral-info", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};


